import './styles/settings.scss';
import $ from 'jquery';
import { renderBanner } from './js/floating';

(($) => {
	'use strict';

	function uuidv4() {
		return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
			(
				c ^
				(crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
			).toString(16)
		);
	}

	const initTabs = () => {
		const tabs = $('.eyezonButtonTab'),
			firstTab = tabs.first(),
			parent = firstTab.parents().first();

		$('<div id="tabs" class="settings-tab">').appendTo(parent);
		const tabsContainer = $('#tabs');

		tabs.each((i, e) => {
			const tab = $(e),
				id = tab.find('.buttonId input').val();

			tab.find('.cmb-remove-group-row-button').appendTo(
				tab.find('.cmb-repeatable-grouping')
			);

			$(e).attr('id', `tabs-${id}`);
		});

		const addButton = $('.cmb-add-group-row'),
			removeButton = $('.cmb-remove-group-row-button'),
			parentRow = addButton.parents('.cmb-row').first(),
			selector = $('.tabsSelector');

		addButton.appendTo(tabsContainer);
		selector.appendTo(tabsContainer);
		tabs.appendTo(tabsContainer);

		tabsContainer.tabs();

		parentRow.remove();

		removeButton.on('click', (e) => {
			const button = $(e.currentTarget),
				tab = button.parents('.eyezonButtonTab'),
				link = $(`[aria-controls="${tab.attr('id')}"]`);

			window.eyezonRemoveTab = {};
			window.eyezonRemoveTab.tab = tab;
			window.eyezonRemoveTab.link = link;
		});

		$('.cmb-repeatable-group').on('cmb2_remove_row', (e) => {
			if (e.group) {
				window.eyezonRemoveTab.tab.remove();
				window.eyezonRemoveTab.link.remove();
				$('.ui-tab a').first().click();

				const removeButtons = $('.cmb-remove-group-row-button');
				removeButtons.show();
				if (removeButtons.length === 1) {
					removeButtons.hide();
				}
			}
		});

		addButton.on('click', () => {
			setTimeout(() => {
				const lastTabButton = $('.ui-tabs-tab').last(),
					newTabButton = lastTabButton.clone(),
					newTabLink = newTabButton.find('a'),
					newTab = $('.cmb-repeatable-grouping').last(),
					currentRemoveButton = newTab.find(
						'.cmb-remove-group-row-button'
					),
					newTabId = uuidv4();

				newTabButton
					.attr('aria-controls', `tabs-${newTabId}`)
					.removeClass('ui-state-active');
				newTabLink
					.attr('href', `#tabs-${newTabId}`)
					.text(window.eyezonNewButtonText);
				newTabButton.appendTo(selector);

				$(
					`<div id="tabs-${newTabId}" class="wrap eyezonButtonTab ${newTabId}">`
				).appendTo(tabsContainer);
				const newTabContainer = $(`.${newTabId}`);
				newTab.appendTo(newTabContainer);
				currentRemoveButton.appendTo(newTab);
				currentRemoveButton.on('click', (e) => {
					const button = $(e.currentTarget),
						tab = button.parents('.eyezonButtonTab'),
						link = $(`[aria-controls="${tab.attr('id')}"]`);

					window.eyezonRemoveTab = {};
					window.eyezonRemoveTab.tab = tab;
					window.eyezonRemoveTab.link = link;
				});

				const removeButtons = $('.cmb-remove-group-row-button');
				removeButtons.show();

				tabsContainer.tabs('refresh');
			}, 500);
		});
	};
	const initSingleMultiToggle = () => {
		const addButtonToggle = () => {
			const addButton = $('.cmb-add-group-row'),
				radio = $('.buttonsCount input:checked'),
				title = $('.buttonsUrlTitle'),
				urls = $('.buttonUrl'),
				tabs = $('.ui-tabs-tab');
			if (radio.val() === 'single') {
				tabs.attr('disabled', 'disabled').addClass('disabled');
				tabs.first()
					.removeAttr('disabled', 'disabled')
					.removeClass('disabled');
				addButton.attr('disabled', 'disabled').addClass('disabled');
				title.hide();
				urls.hide();
			} else {
				addButton
					.removeAttr('disabled')
					.removeClass('disabled')
					.removeClass('disabled');
				tabs.removeAttr('disabled').removeClass('disabled');
				title.show();
				urls.show();
			}
		};
		$('.buttonsCount input').change(addButtonToggle);
		addButtonToggle();
	};
	const initRender = () => {
		const render = (e) => {
			const current = $(e),
				tab = current.parents('.eyezonButtonTab'),
				previewContainer = tab.find('.previewContainer'),
				valueGetter = (selector, defaultValue, checkable = false) => {
					if (checkable) {
						selector += ':checked';
					}

					return tab.find(selector).val() || defaultValue;
				},
				config = [
					0,
					valueGetter(
						'.buttonMainText textarea',
						window.EYEZON_DATA.mainText
					),
					valueGetter(
						'.buttonText input',
						window.EYEZON_DATA.buttonText
					),
					valueGetter('.buttonsPosition input', 'left', true),
					valueGetter('.buttonHorizontalMargin input', 24),
					valueGetter('.buttonBottomMargin input', 24),
				];

			tab.find('.floatingbanner').remove();
			renderBanner(document, config, previewContainer);
		};

		$('.renderBanner input, .renderBanner textarea')
			.change((e) => render(e.currentTarget))
			.keyup((e) => render(e.currentTarget));

		$('.eyezonButtonTab').each((i, e) => {
			render($(e).find('.buttonText'));
		});
	};
	const fixRepeatableValidation = () => {
		const addButton = $('.cmb-add-row-button'),
			countSelect = $('input[name="buttonsCount"]'),
			removeValidationFromUrlsList = () => {
				const buttonCount = $(
					'input[name="buttonsCount"]:checked'
				).val();
				if (buttonCount === 'single') {
					$('[name*="buttonsUrl"]').removeAttr('required');
				}
			},
			setRequired = (el) => {
				$(el)
					.parents('.cmb-td')
					.first()
					.find('input')
					.attr('required', 'required');

				setTimeout(() => {
					$(el)
						.parents('.cmb-td')
						.first()
						.find('.empty-row input')
						.removeAttr('required');
				}, 250);
			};

		addButton.each((i, el) => {
			setRequired(el);
		});

		addButton.click((e) => {
			setTimeout(setRequired(e.currentTarget), 500);
		});

		countSelect.change(() => removeValidationFromUrlsList());
		removeValidationFromUrlsList();
	};

	const initFormValidation = () => {
		const form = $('.cmb-form'),
			button = form.find('input[type="submit"]');

		button.on('click', () => {
			const notValid = form.find(
				'.eyezonButtonTab input:invalid, .eyezonButtonTab textarea:invalid'
			);
			if (notValid.length === 0) {
				return;
			}

			const first = notValid.first(),
				tab = first.parents('.eyezonButtonTab'),
				link = $(`[aria-controls="${tab.attr('id')}"] a`);

			link.click();
			$([document.documentElement, document.body]).animate(
				{
					scrollTop: first.offset().top - 100,
				},
				200
			);
			notValid.first().focus();
		});
	};

	$(() => {
		initTabs();
		initSingleMultiToggle();
		initRender();
		fixRepeatableValidation();
		initFormValidation();
	});
})(jQuery);
